import { createContext, useContext } from 'react';

export const AgentEditContext = createContext(null);

export const useAgentEdit = () => {
  const value = useContext(AgentEditContext);
  if (!value) {
    throw new Error('useAgentEdit must be used within AgentEditContext.Provider');
  }
  return value;
};
